import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { EditTextFieldDialog } from "../core/EditTextFieldDialog";

/**
 * @param {string|number|undefined} raw
 * @returns {string[]}
 */
const tagLabelsFromRaw = (raw) =>
  String(raw ?? "")
    .split(",")
    .map((t) => t.trim().toLowerCase())
    .filter(Boolean);

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string|number|undefined} props.text
 */
const TagsDisplay = ({ title, text }) => {
  const tagLabels = tagLabelsFromRaw(text);
  return (
    <ListItemText
      primary={title}
      secondary={
        tagLabels.length > 0 ? (
          <Stack direction="row" flexWrap="wrap" gap={0.5} useFlexGap sx={{ pt: 0.5 }}>
            {tagLabels.map((label, index) => (
              <Chip key={`${label}-${index}`} label={label} />
            ))}
          </Stack>
        ) : (
          "click to edit"
        )
      }
      secondaryTypographyProps={{ component: "div" }}
      sx={{ maxWidth: "66ch" }}
    />
  );
};

/**
 * Comma-separated tags in the dialog; chips (lowercase) in the list.
 *
 * @param {object} props
 * @param {string} props.title
 * @param {string|number|undefined} props.text
 * @param {string} props.helperText
 * @param {boolean} [props.disabled]
 * @param {(text: string) => void | Promise<void>} props.onSave
 */
export const EditableTagsListItem = ({ title, text, helperText, onSave, disabled }) => {
  return (
    <Stack direction="row" display="flex" justifyContent="flex-end">
      {disabled ? (
        <TagsDisplay title={title} text={text} />
      ) : (
        <Box>
          <EditTextFieldDialog
            onSave={onSave}
            title={title}
            initialValue={text}
            isBusy={false}
            helperText={helperText}
            multiline
            onEnterDisabled
          >
            <TagsDisplay title={title} text={text} />
          </EditTextFieldDialog>
        </Box>
      )}
    </Stack>
  );
};
